module.exports = __webpack_public_path__ + "img/fr_upgrade_page_mobile_banner.23acea0a.png";